<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                    {
                        name: $tc('messages.groups', 2),
                        href: meta.links.index,
                    },
                    {
                        name: group.name,
                        href: meta.links.show,
                    },
                    {
                        name: $t('messages.edit'),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.update" method="post" @submit.prevent="submit">
            <TitleFieldsFormSection>
                <template v-slot:title>
                    <div>{{ $t('messages.information') }}</div>
                    <img v-if="group.image_path" class="w-40 h-40 object-contain" :src="group.image_path" alt="" />
                </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.name')" for="name" />
                            <FormInput id="name" v-model="form.name" name="name" type="text" max="60" class="mt-1" />
                            <FormError :value="form.errors.name" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.image')" for="image" />
                            <input
                                id="image"
                                @input="form.image = $event.target.files[0]"
                                name="image"
                                type="file"
                                accept="image/*"
                                class="mt-1 w-full"
                            />
                            <FormError :value="form.errors.image" class="mt-2" />
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>

            <TitleFieldsFormSection>
                <template v-slot:title>
                    <div>{{ $tc('messages.permissions', 2) }}</div>
                </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel
                                :value="$t('messages.students_can_upload_avatars')"
                                for="students_can_upload_avatars"
                            />
                            <input
                                id="students_can_upload_avatars"
                                type="checkbox"
                                v-model="form.students_can_upload_avatars"
                                class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                            />
                            <FormError :value="form.errors.students_can_upload_avatars" class="mt-2" />
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>

            <TitleFieldsFormSection>
                <template v-slot:title>
                    <div>{{ $t('messages.group_student_position') }}</div>
                    <div class="text-sm leading-5 text-gray-500">
                        {{ $t('messages.group_student_position_explanation') }}
                    </div>
                    <div class="mt-1 flex gap-2">
                        <AppButton type="button" @click="resetPositions" class="cursor-pointer">
                            {{ $t('messages.reset') }}
                        </AppButton>
                        <AppButton type="button" @click="sortAlphabetically" class="cursor-pointer">
                            {{ $t('messages.sort_alphabetically') }}
                        </AppButton>
                    </div>
                </template>
                <div class="">
                    <div v-for="(student, index) in form.students" :key="index" class="mb-2 flex items-center">
                        <div class="flex items-center mt-1 gap-2">
                            <FormInput
                                v-model="student.position"
                                type="number"
                                step="1"
                                min="1"
                                max="250"
                                :name="`students_${students[student.id]}`"
                            />
                            <FormLabel :value="student.full_name" :for="`students_${students[student.id]}`" />
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>

            <div class="flex justify-end mt-5">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
            </div>
        </form>
    </PanelPage>
</template>

<script>
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';
import Layout from '@/Shared/Layout.vue';
import AppButton from '../../../components/AppButton.vue';

export default {
    components: {
        AppButton,
        SubmitFormButton,
        PanelPage,
        TitleFieldsFormSection,
        FormInput,
        FormLabel,
        FormError,
    },
    layout: Layout,
    name: 'Edit',
    props: ['teacher', 'meta', 'options', 'group', 'students'],
    data() {
        return {
            form: this.$inertia.form({
                _method: 'patch',
                name: this.group.name,
                students_can_upload_avatars: this.group.students_can_upload_avatars,
                image: null,
                students: this.students,
            }),
        };
    },
    methods: {
        submit() {
            this.form.post(this.meta.links.update);
        },
        resetPositions() {
            this.form.students.forEach((student) => {
                student.position = null;
            });
        },
        sortAlphabetically() {
            this.form.students.sort((a, b) => {
                return a.full_name.localeCompare(b.full_name);
            });
            this.form.students.forEach((student, index) => {
                student.position = index + 1;
            });
        },
    },
};
</script>
